import type { SVGProps } from 'react';
const SvgPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
    viewBox="0 0 512 512"
    {...props}
  >
    <path
      d="M268.8 501.333c-9.956 0-22.222-3.022-36.8-9.066-14.578-6.045-21.867-15.823-21.867-29.334V316.8l-9.6-4.267h-20.266c-17.778 0-36.089.889-54.934 2.667-18.844 1.778-37.511 2.667-56 2.667H33.067c-14.223-3.556-23.289-10.489-27.2-20.8C1.956 286.756 0 275.556 0 263.467c0-14.223 4.978-27.556 14.933-40C24.889 211.022 38.044 204.8 54.4 204.8h145.067c-.711-25.6-1.778-48.178-3.2-67.733-1.423-19.556-2.134-38.578-2.134-57.067V46.933c4.978-11.377 12.623-20.266 22.934-26.666 10.311-6.4 20.8-9.6 31.466-9.6 20.623 0 35.556 7.644 44.8 22.933 9.245 15.289 13.867 32.533 13.867 51.733V204.8c29.156-.711 55.467-1.778 78.933-3.2 23.467-1.422 45.867-2.133 67.2-2.133 16.356 0 30.223 4.089 41.6 12.266C506.311 219.911 512 231.822 512 247.467c0 11.377-3.733 23.289-11.2 35.733-7.467 12.444-16.178 18.667-26.133 18.667H312.533v166.4c0 4.977-2.844 10.133-8.533 15.466a69.696 69.696 0 0 1-19.2 12.8c-7.111 3.2-12.444 4.8-16 4.8Z"
      style={{
        fillRule: 'nonzero',
      }}
    />
  </svg>
);
export default SvgPlus;
